import React from "react"
import { graphql, Link, useStaticQuery } from "gatsby"
import { motion } from "framer-motion"

function HomeCards({ title, slug, posts, excerpt, bgImg }) {
  const data = useStaticQuery(graphql`
    query {
      desktopdev: allMarkdownRemark(
        filter: {
          frontmatter: { category: { eq: "desktop-dev" }, type: { eq: "blog" } }
        }
      ) {
        totalCount
      }
      webdev: allMarkdownRemark(
        filter: {
          frontmatter: { category: { eq: "web-dev" }, type: { eq: "blog" } }
        }
      ) {
        totalCount
      }
      mobiledev: allMarkdownRemark(
        filter: {
          frontmatter: { category: { eq: "mobile-dev" }, type: { eq: "blog" } }
        }
      ) {
        totalCount
      }
      tech: allMarkdownRemark(
        filter: {
          frontmatter: { category: { eq: "tech" }, type: { eq: "blog" } }
        }
      ) {
        totalCount
      }
      cp: allMarkdownRemark(
        filter: {
          frontmatter: { category: { eq: "cp" }, type: { eq: "blog" } }
        }
      ) {
        totalCount
      }
      myjourney: allMarkdownRemark(
        filter: {
          frontmatter: { category: { eq: "my-journey" }, type: { eq: "blog" } }
        }
      ) {
        totalCount
      }
      programming: allMarkdownRemark(
        filter: {
          frontmatter: { category: { eq: "programming" }, type: { eq: "blog" } }
        }
      ) {
        totalCount
      }
      dsa: allMarkdownRemark(
        filter: {
          frontmatter: { category: { eq: "dsa" }, type: { eq: "blog" } }
        }
      ) {
        totalCount
      }
      cssubjects: allMarkdownRemark(
        filter: {
          frontmatter: { category: { eq: "cs-subjects" }, type: { eq: "blog" } }
        }
      ) {
        totalCount
      }
    }
  `)
  return (
    <motion.div
      variants={homeCardsVariants}
      initial="hidden"
      animate="visible"
      whileHover="onHover"
      whileTap="onTap"
      className="col-md-5 mx-4 mx-md-auto my-3 homeCard"
      id={bgImg}
    >
      <Link
        to={`/category/${slug}`}
        className="text-white text-decoration-none"
      >
        <div className="title-wrapper">
          <h3 className="my-0 category-title">{title}</h3>
          {excerpt && (
            <span>
              <small>
                <strong className="text-info">{excerpt}</strong>
              </small>
            </span>
          )}
        </div>
        {data[`${slug.replace("-", "")}`] && (
          <p className="noOfPosts">
            {data[`${slug.replace("-", "")}`]?.totalCount}{" "}
            {data[`${slug.replace("-", "")}`]?.totalCount === 1
              ? "post"
              : "posts"}
          </p>
        )}
      </Link>
    </motion.div>
  )
}

export default HomeCards

const homeCardsVariants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 1,
    transition: { delay: 1, duration: 0.5 },
  },
  onHover: {
    scale: 1.07,
    // boxShadow: "0 10px 40px rgba(0, 0, 0, 0.4)",
  },
  onTap: {
    scale: 0.95,
  },
}
